export default __webpack_public_path__ + "tmp_src/components/HostGallery/HostGalleryItem.css.liquid";